<template>
    <div class="container">
        <content-header :title="departmentsDetail.title" />
        <div class="department-detail-container">
            <div class="department-detail-container-top">
                <img class="department-image" :src="departmentsDetail.logo && departmentsDetail.logo.full_size"
                    :alt="departmentsDetail.title">
            </div>
            <div class="department-detail-choose" id="scrollTo">
                <div class="department-tabs">
                    <div class="tab" :class="{ 'tab--active': tab === 'info' }" @click="tab = 'info'">Об Отделении</div>
                    <div class="tab" :class="{ 'tab--active': tab === 'prices' }" @click="tab = 'prices'">Услуги и Цены
                    </div>
                    <div class="tab" :class="{ 'tab--active': tab === 'specialist' }" @click="tab = 'specialist'">
                        Специалисты
                    </div>
                    <div class="tab" :class="{ 'tab--active': tab === 'gallery' }" @click="tab = 'gallery'">
                        Галерея
                    </div>
                    <div class="tab" :class="{ 'tab--active': tab === 'offers' }" @click="tab = 'offers'">
                        Актуальная информация
                    </div>
                </div>

                <div class="department-info" v-show="tab === 'info'">
                    <div class="department-info__content" v-if="departmentsDetail.long_description"
                        v-html="departmentsDetail.long_description" />
                    <!--<div class="department-info__content" v-if="departmentsDetail.short_description"-->
                    <!--   v-html="departmentsDetail.short_description"/>-->
                    <div v-if="departmentsDetail.info_tabs">
                        <static-page-tabs :data="departmentsDetail.info_tabs" />
                    </div>
                </div>
                <div class="department-price" v-if="tab === 'prices'">
                    <div class="search-input">
                        <span>Поиск: </span>
                        <input type="text" @keyup="filterSchedule" v-model="search">
                    </div>
                    <prices-table @sort="sortData" @pageChanged="currentPage" @scrollTop="scroll" ref="scrollTo"
                        :data="priceAndServices" />
                </div>


                <div class="doctors-list" v-if="tab === 'specialist'">
                    <DoctorInfo :data="departmentDoctors" :no_title="true" />
                </div>

                <div class="gallery" v-if="tab === 'gallery'">
                </div>
                <div class="offers-list" v-if="tab === 'offers'">
                    <div class="offer-card" v-for="offer in offers">
                        <router-link
                            :to="{ name: offer.is_special ? 'specialPrograms' : 'offerDetail', params: { title: offer.slug } }"
                            class="offer-img">
                            <img :src="offer.photo ? offer.photo.crop : ''" :alt="offer.title">
                        </router-link>
                        <div class="offer-link">
                            <router-link
                                :to="{ name: offer.is_special ? 'specialPrograms' : 'offerDetail', params: { title: offer.slug } }">
                                {{ offer.title }}
                            </router-link>
                        </div>
                    </div>
                    <div class="offer-card" v-for="offer in news">
                        <router-link :to="{ name: 'articleDetail', params: { title: offer.slug } }" class="offer-img">
                            <img :src="offer.photo ? offer.photo.crop : ''" :alt="offer.title">
                        </router-link>
                        <div class="offer-link">
                            <router-link :to="{ name: 'articleDetail', params: { title: offer.slug } }">
                                {{ offer.title }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <template v-if="this.$route.params.slug === 'ведение-беременности' && tab === 'info'">
                    <div class="divider"></div>
                    <br>
                    <div class="flex">
                        <div class="box">
                            <img src="../assets/images/staticPages/pdf-icon-png-2068-200x200.png" alt="pdf" height="200"
                                width="200" />
                            <a class="link" target="_blank"
                                href="/static/files/staticContent/ПРЕДВАРИТЕЛЬНОЕ-ОБСЛЕДОВАНИЕ.pdf"><span>ПРЕДВАРИТЕЛЬНОЕ
                                    ОБСЛЕДОВАНИЕ</span></a>
                        </div>
                        <div class="box">
                            <img src="../assets/images/staticPages/pdf-icon-png-2068-200x200.png" alt="pdf" height="200"
                                width="200" />
                            <a class="link" target="_blank"
                                href="/static/files/staticContent/ВЕДЕНИЕ-БЕРЕМЕННОСТИ-СТАНДАРТ.pdf"><span>ВЕДЕНИЕ
                                    БЕРЕМЕННОСТИ СТАНДАРТ</span></a>
                        </div>
                        <div class="box">
                            <img src="../assets/images/staticPages/pdf-icon-png-2068-200x200.png" alt="pdf" height="200"
                                width="200" />
                            <a class="link" target="_blank"
                                href="/static/files/staticContent/ВЕДЕНИЕ-БЕРЕМЕННОСТИ-VIP.pdf"><span>ВЕДЕНИЕ
                                    БЕРЕМЕННОСТИ VIP</span></a>
                        </div>
                    </div>
                    <br>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../components/layout/ContentHeader";
import pricesTable from "../components/pricesTable";
import ServiceAndPricesMixin from "../mixins/ServiceAndPricesMixin";
import StaticPageTabs from "../components/StaticPageTabs";
import DoctorInfo from "@/components/DoctorInfo";
import DepartmentStaticTable from "@/components/DepartmentStaticTable";
import RegistrationBlogs from "../components/RegistrationBlogs";
import { mapActions, mapGetters } from "vuex";
import Vue from 'vue';

export default {
    components: {
        ContentHeader,
        pricesTable,
        DoctorInfo,
        StaticPageTabs
    },
    mixins: [ServiceAndPricesMixin],
    data() {
        return {
            tab: 'info',
            search: '',
        }
    },
    computed: {
        ...mapGetters(["news", "offers", "departmentDoctors"])
    },
    methods: {
        ...mapActions(["fetchDepartmentDoctors", "fetchNews", "fetchOffers"]),
        replaceTable() {
            const pregnancy_table = document.querySelector('#pregnancy_table');
            if (pregnancy_table) {
                const table = Vue.extend(DepartmentStaticTable);
                const append_table = new table().$mount();
                pregnancy_table.innerHTML = '';
                pregnancy_table.appendChild(append_table.$el);
            }

            const registration_blogs = document.querySelector('#registration_blogs');
            if (registration_blogs) {
                const table = Vue.extend(RegistrationBlogs);
                const append_table = new table().$mount();
                registration_blogs.innerHTML = '';
                registration_blogs.appendChild(append_table.$el);
            }
        },
        filterSchedule() {
            const query = { ...this.$route.query };
            if (this.search === '') {
                delete query.name
            } else {
                query.name = this.search;
            }
            this.$router.replace({ query });
        },
    },
    mounted() {
        this.fetchDepartmentsDetail(String(this.$route.params.slug)).then(() => {
            this.fetchDepartmentDoctors(this.departmentsDetail.slug);
            this.fetchOffers({ department: this.departmentsDetail.id, is_finished: 0, includeSpecials: 1 });
            this.fetchNews({ departmentSlug: this.departmentsDetail.slug });
            this.replaceTable();
        })
    },
    destroyed() {
        this.$store.commit('setData', { key: 'departmentsDetail', value: [], module: 'home' });
    }
}
</script>

<style lang="scss" scoped>
.offers-list {
    grid-template-columns: repeat(auto-fill,225px);
    display: grid;
    justify-content: space-between;
    grid-column-gap: 10px;
    grid-row-gap: 10px;

    .offer-card {
        display: block;
        width: min-content;

        .offer-img {
            display: block;

            img {
                width: 225px;
                height: 150px;
            }
        }

        .offer-link {
            display: block;
            text-align: center;
            margin-top: 20px;

            a {
                width: fit-content;
                color: #000;
                font-weight: bold;
                border-bottom: 1px dotted #006688;
                text-decoration: none;
                outline: none;
                font-size: 13px;
                white-space: normal;
            }
        }
    }
}

.department-detail-container-top {
    display: grid;
    grid-template-columns: 120px auto;
    grid-template-rows: auto;
}

.department-image {
    width: 100px;
    height: 100px;
    margin: 30px auto 30px 0;
}

.department-detail-container {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.department-tabs {
    font-size: 14px;
    display: flex;
    margin: 20px 0;

    .tab {
        color: #666;
        margin-right: 15px;
        cursor: pointer;

        &--active,
        &:hover {
            color: #000;
            border-bottom: 1px solid #00b6cc;
        }
    }
}
</style>

<style lang="scss">
.department-info__content {
    text-align: left;

    p {
        padding: 1em 0;
        //margin-top: -1.5em;
        margin-bottom: -1.5em;
        text-align: justify;
        font-family: Arial, sans-serif;
        font-size: small;
        color: #666;
        line-height: 150%;
    }

    strong {
        font-weight: bold;
        color: inherit;
        line-height: inherit;
    }

    img {
        max-width: 100%;
        height: fit-content !important;
    }
}

.department-detail-container {
    .department-doctors {
        .doctor-detail {
            grid-column-gap: 10%;
            background-color: unset;

            &__title {
                &:after {
                    content: "";
                    background-color: #00b6cc;
                    width: 50px;
                    height: 2px;
                    display: block;
                    margin-top: 15px;
                }
            }

            &__content-item {
                img {
                    width: 300px;
                    height: 300px;

                    @media screen and (max-width: 450px) {
                        width: 200px;
                        height: 200px;
                    }
                }
            }
        }
    }
}


.department-price {

    .search-input {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 20px 0;

        span {
            font-size: 13px;
            margin-right: 10px;
            margin-top: 4px;
        }

        input {
            background-color: #fff;
            padding: 5px;
            border: 1px solid;
            color: #000;
        }
    }
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
    justify-content: space-around;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: black;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    font-weight: bold;
}

.link span {
    border-bottom: 1px dotted black;
}
</style>
